// middleware/auth.global.ts
export default defineNuxtRouteMiddleware(async (to) => {
  const { loggedIn, refresh, needsRefresh } = useAuth();

  // Define public routes
  const publicRoutes = ["/"];

  // Allow public routes
  if (to.path.startsWith("/public/") || to.path.startsWith("/l/")) {
    return;
  }

  // For admin routes, we don't need to check regular auth
  if (to.path.startsWith("/admin")) {
    return;
  }

  if (to.path.startsWith("/api/upload-image")) {
    return;
  }

  if (to.path.startsWith("/api/check-image-exists")) {
    return;
  }

  // Check if current route is public
  if (publicRoutes.includes(to.path)) {
    return;
  }

  try {
    // Only refresh if logged in and needs refresh
    if (loggedIn.value && needsRefresh.value) {
      await refresh();
    }

    // After potential refresh, if not logged in and not on a public route, redirect
    if (!loggedIn.value) {
      return navigateTo("/");
    }
  } catch (error) {
    console.error("Auth refresh error:", error);
    if (
      (error as { statusCode?: number })?.statusCode === 401 ||
      (error as { data?: { clearAuth?: boolean } })?.data?.clearAuth
    ) {
      return navigateTo("/");
    }
  }
});
